import React from "react";
import { Button } from "@design-system/Button/Button";
import { CollapseIcon, ExpandIcon } from "@icons";
import { useCashFlowExpandContext } from "./cash-flow-expand.context";

export const CashFlowExpandCollapseButton: React.FC = () => {
    const { isAllCollapsed, expandAll, collapseAll } =
        useCashFlowExpandContext();

    return (
        <Button
            variant="primary"
            size="md"
            iconOnly
            onClick={isAllCollapsed ? expandAll : collapseAll}
            aria-label={isAllCollapsed ? "Expand all" : "Collapse all"}
        >
            {isAllCollapsed ? <ExpandIcon /> : <CollapseIcon />}
        </Button>
    );
};
